import { render, staticRenderFns } from "./ArtworkEditor.vue?vue&type=template&id=401167f5&scoped=true"
import script from "./ArtworkEditor.vue?vue&type=script&lang=js"
export * from "./ArtworkEditor.vue?vue&type=script&lang=js"
import style0 from "./ArtworkEditor.vue?vue&type=style&index=0&id=401167f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401167f5",
  null
  
)

export default component.exports